import { render, staticRenderFns } from "./NewsDetail53.vue?vue&type=template&id=70760ddb&scoped=true"
import script from "./NewsDetail53.vue?vue&type=script&lang=js"
export * from "./NewsDetail53.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail53.vue?vue&type=style&index=0&id=70760ddb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70760ddb",
  null
  
)

export default component.exports